import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'tanok';
import { t } from 'c-3po';
import classSet from 'classnames';
import {
    getRoom,
    BESIDA_ROLE_COMPANY,
    BESIDA_ROLE_BUYER
} from '@evo/chat-core';
import { Sticky } from 'react-sticky';

import * as a from '../../../../../../../libs/actions';
import * as c from '../../../../../../../libs/constants';
import * as aggr from '../../../../../../../libs/aggregation';
import {
    getCreateOrderCabinetUrl,
    getProductPortalUrl,
    validateCountryPrice,
} from '../../../../../../../libs/helpers/prom';
import { getSocketStore, getMessageStatus } from '../../../../../../../libs/utils';
import { Config } from '../../../../../../../core/config';

import { toJS } from '../../../../../../helpers/ImmutableToJS';
import { Processing } from './../processing';

import { Icon } from '../../../../../../ui/icon';

// styles
import css from './contextMessage.sss';

// images
import LinkIconSvg from './images/link.icon.svg';
import BasketIconSvg from './images/basket.icon.svg';
import EyeIconSvg from './images/eye.icon.svg';
import MoreVerticalIconSvg from './images/moreVertical.icon.svg';


class ContextMsgView extends React.Component {

    static propTypes = {
        users: PropTypes.object,
        roomIdent: PropTypes.string,
        msgId: PropTypes.number,
        msg: PropTypes.object,
        messageStatus: PropTypes.string,
        dialogOwner: PropTypes.any,
        newMsgMarkShown: PropTypes.any,
        retrySendMsg: PropTypes.func,
    };

    sendAnaliticsAction = (action) => {
        return () => this.props.send(a.TR_SEND_ANALITICS_ACTION, { action });
    }


    handleActionChange = (event, createUrl, viewUrl) => {
        const actionValue = event.target.value;
        let actionUrl;
        if (actionValue === 'create') {
            this.handleOrderClick();
            actionUrl = createUrl;
        }
        if (actionValue === 'view') {
            this.sendAnaliticsAction(c.ANALCS_ACTION_VIEW_PRODUCT);
            actionUrl = viewUrl;
        }
        window.open(actionUrl,'_blank');
    }

    handleOrderClick = () => {
        const { newMsgInCurrentDialog, newMsgMarkShown } = this.props;
        this.props.send(a.EVENT_MARK_MSG_READ, { newMsgInCurrentDialog, newMsgMarkShown });
        this.sendAnaliticsAction(c.ANALCS_ACTION_CREATE_ORDER);
    }

    renderCompanyStickyCntx() {
        const { msg, dialogOwner, currentChatRoom, users, isNewCabinet } = this.props;
        const { IS_PREMIUM_SERVICE_FREE } = Config.data.appState;
        const companyType = currentChatRoom.extra && currentChatRoom.extra.company_type;

        const showCreateOrder = (
            !IS_PREMIUM_SERVICE_FREE
            && msg.context_item_id
            && users[msg.user_ident].role === BESIDA_ROLE_BUYER
            && users[dialogOwner].role === BESIDA_ROLE_COMPANY
            && companyType === c.COMPANY_B2C_TYPE
        );

        const createUrl = getCreateOrderCabinetUrl(
            msg.user_ident,
            msg.context_item_id,
            isNewCabinet,
            currentChatRoom.room_ident,
            msg.context_meta
        );

        const viewUrl = getProductPortalUrl(msg.context_item_id);

        return (
            <span className={css.actions}>
                <Icon className={css.actionsIcon} glyph={MoreVerticalIconSvg} />
                <select
                    className={css.actionsSelect}
                    onChange={(event) => this.handleActionChange(event, createUrl, viewUrl)}
                    defaultValue=''
                >
                    <option value='' hidden />
                    {showCreateOrder && (
                        <option
                            value='create'
                            data-qaid='create_order'
                            data-url={createUrl}
                        >
                            {t`Создать заказ`}
                        </option>
                    )}
                    <option
                        value='view'
                        data-qaid='view_product'
                        data-url={viewUrl}
                    >
                        {t`Посмотреть`}
                    </option>
                </select>
            </span>
        );
    }

    renderCompanyCntx() {
        const { msg, dialogOwner, currentChatRoom, users, isNewCabinet } = this.props;

        const { IS_PREMIUM_SERVICE_FREE } = Config.data.appState;

        const companyType = currentChatRoom.extra && currentChatRoom.extra.company_type;

        const showCreateOrderLink = (
            !IS_PREMIUM_SERVICE_FREE
            && msg.context_item_id
            && users[msg.user_ident].role === BESIDA_ROLE_BUYER
            && users[dialogOwner].role === BESIDA_ROLE_COMPANY
            && companyType === c.COMPANY_B2C_TYPE
        );

        return (
            <ul className={css.companyLinks}>
                {showCreateOrderLink && (
                    <li className={css.companyLinksItem}>
                        <a
                            href={getCreateOrderCabinetUrl(
                                msg.user_ident,
                                msg.context_item_id,
                                isNewCabinet,
                                currentChatRoom.room_ident,
                                msg.context_meta,
                            )}
                            className={css.companyLinksButton}
                            title={t`Создать заказ`}
                            data-qaid='create_order_icon'
                            target='_blank'
                            onClick={this.handleOrderClick}
                        >
                            <Icon
                                className={css.companyLinksIcon}
                                glyph={BasketIconSvg}
                            />
                            <span>{t`Создать заказ`}</span>
                        </a>
                    </li>
                )}
                <li className={css.companyLinksItem}>
                    <a
                        href={getProductPortalUrl(msg.context_item_id)}
                        className={css.companyLinksButton}
                        title={t`Посмотреть товар`}
                        target='_blank'
                        data-qaid='view_product_icon'
                        onClick={this.sendAnaliticsAction(c.ANALCS_ACTION_VIEW_PRODUCT)}
                    >
                        <Icon
                            className={css.companyLinksIcon}
                            glyph={EyeIconSvg}
                        />
                        <span>{t`Посмотреть`}</span>
                    </a>
                </li>
            </ul>
        );
    }

    renderClientCntx() {
        return (
            <div className={css.clientLinks}>
                <a
                    href={getProductPortalUrl(this.props.msg.context_item_id)}
                    className={css.clientLink}
                    title={t`Посмотреть товар`}
                    target='_blank'
                    data-qaid='view_product_icon'
                    onClick={this.sendAnaliticsAction(c.ANALCS_ACTION_VIEW_PRODUCT)}
                >
                    <span className={css.clientLinkText}>{t`Посмотреть`}</span>
                    <Icon
                        className={css.clientLinkIcon}
                        glyph={LinkIconSvg}
                    />
                </a>
            </div>
        );
    }

    render() {
        const { msg, currentChatRoom, userRole, messageStatus, retrySendMsg, disabledChat } = this.props;

        const isInCompanyRole = userRole === BESIDA_ROLE_COMPANY;
        const isBannedRoom = currentChatRoom.companyBanned || currentChatRoom.clientBanned;

        const finalMarkUp = (isSticky) => {

            const totalClasses = classSet(
                css.holder,
                {
                    [css.fixed]: isSticky,
                    [css.companyView]: isInCompanyRole,
                },
            );

            return (
                <div
                    className={totalClasses}
                    data-cntx-id={msg.id}
                    key={msg.id}
                    data-qaid='context_block'
                >
                    <div className={css.body}>
                        <div className={css.info}>
                            <div
                                className={css.title}
                                title={msg.context_description}
                                data-qaid='product_name'
                            >
                                {msg.context_description}
                            </div>
                            <div
                                className={css.price}
                                data-qaid='product_price'
                            >
                                {validateCountryPrice(
                                    msg.context_item_price, msg.context_item_currency)}
                            </div>
                        </div>
                        {!isInCompanyRole && this.renderClientCntx()}
                        {isSticky && isInCompanyRole && this.renderCompanyStickyCntx()}
                    </div>
                    {!isSticky && isInCompanyRole && this.renderCompanyCntx()}
                    {!isSticky && (
                        <span className={css.source}>
                            {t`Отправлено со страницы товара`}
                        </span>
                    )}
                    <Processing
                        status={messageStatus}
                        retry={retrySendMsg}
                        msgId={msg.id}
                    />
                </div>
            );
        };

        return (isBannedRoom || disabledChat) ? finalMarkUp() : (
            <li className={css.root}>
                <Sticky relative disableCompensation>
                    {({ isSticky }) => finalMarkUp(isSticky)}
                </Sticky>
            </li>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const socketStore = getSocketStore(state);
    const currentChatRoom = getRoom(socketStore, state.get('openedRoomIdent'));
    const dialogOwner = aggr.getDialogOwner(state);


    const msg = currentChatRoom.get('history').find((m) => m.get('id') === ownProps.msgId);
    const messageStatus = getMessageStatus(state, msg);
    const isPortalChatVisible = !!currentChatRoom.getIn(['extra', 'is_portal_chat_visible']);

    return {
        users: currentChatRoom.get('users'),
        newMsgMarkShown: state.get('newMsgMarkShown'),
        rerenderCounter: state.get('rerenderCounter'),
        newMsgInCurrentDialog: aggr.newMsgInCurrentDialog(currentChatRoom),
        isNewCabinet: state.get('isNewCabinet'),
        userRole: state.get('userRole'),
        locale: state.get('locale'),
        msg,
        dialogOwner,
        currentChatRoom,
        messageStatus,
        disabledChat: !isPortalChatVisible

    };
};

export const ContextMsg = connect(mapStateToProps)(toJS(ContextMsgView));
